import { useState } from 'react';

const documents = [
  {
    id: 1,
    name: 'Lease Agreement — 2025',
    category: 'Lease',
    date: 'Jan 01, 2025',
    size: '1.2 MB',
    type: 'PDF',
    icon: 'ri-file-text-line',
    color: 'text-[#8B7355] bg-[#F5F0E8]',
  },
  {
    id: 2,
    name: 'Lease Renewal Addendum',
    category: 'Lease',
    date: 'Nov 15, 2025',
    size: '340 KB',
    type: 'PDF',
    icon: 'ri-file-add-line',
    color: 'text-[#8B7355] bg-[#F5F0E8]',
  },
  {
    id: 3,
    name: 'March 2026 Financial Statement',
    category: 'Financial',
    date: 'Apr 01, 2026',
    size: '520 KB',
    type: 'PDF',
    icon: 'ri-bar-chart-line',
    color: 'text-emerald-600 bg-emerald-50',
  },
  {
    id: 4,
    name: 'February 2026 Financial Statement',
    category: 'Financial',
    date: 'Mar 01, 2026',
    size: '510 KB',
    type: 'PDF',
    icon: 'ri-bar-chart-line',
    color: 'text-emerald-600 bg-emerald-50',
  },
  {
    id: 5,
    name: 'January 2026 Financial Statement',
    category: 'Financial',
    date: 'Feb 01, 2026',
    size: '498 KB',
    type: 'PDF',
    icon: 'ri-bar-chart-line',
    color: 'text-emerald-600 bg-emerald-50',
  },
  {
    id: 6,
    name: 'Q1 2026 Property Inspection Report',
    category: 'Inspection',
    date: 'Mar 15, 2026',
    size: '2.8 MB',
    type: 'PDF',
    icon: 'ri-search-eye-line',
    color: 'text-amber-600 bg-amber-50',
  },
  {
    id: 7,
    name: 'Q4 2025 Property Inspection Report',
    category: 'Inspection',
    date: 'Dec 20, 2025',
    size: '3.1 MB',
    type: 'PDF',
    icon: 'ri-search-eye-line',
    color: 'text-amber-600 bg-amber-50',
  },
  {
    id: 8,
    name: 'Insurance Certificate 2025–2026',
    category: 'Insurance',
    date: 'Jan 01, 2025',
    size: '890 KB',
    type: 'PDF',
    icon: 'ri-shield-line',
    color: 'text-[#6B6B6B] bg-[#F5F3F0]',
  },
  {
    id: 9,
    name: 'Property Management Agreement',
    category: 'Agreement',
    date: 'Jan 01, 2024',
    size: '1.5 MB',
    type: 'PDF',
    icon: 'ri-file-paper-line',
    color: 'text-[#6B6B6B] bg-[#F5F3F0]',
  },
];

const categories = ['All', 'Lease', 'Financial', 'Inspection', 'Insurance', 'Agreement'];

export default function DocumentsTab() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [search, setSearch] = useState('');

  const filtered = documents.filter((doc) => {
    const matchCat = activeCategory === 'All' || doc.category === activeCategory;
    const matchSearch = doc.name.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="text-2xl font-semibold text-[#1A1A1A]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Documents
        </h2>
        <p className="text-sm text-[#6B6B6B] font-light mt-1">All your property documents, securely stored</p>
      </div>

      {/* Filters */}
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1 max-w-sm">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
            <i className="ri-search-line text-[#AEAAA4] text-sm"></i>
          </div>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search documents..."
            className="w-full pl-9 pr-4 py-2.5 bg-white border border-[#E0DDD9] rounded-md text-sm text-[#1A1A1A] placeholder-[#AEAAA4] focus:outline-none focus:border-[#8B7355] transition-colors"
          />
        </div>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-3 py-2 rounded-md text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-[#2C2C2C] text-white'
                  : 'bg-white border border-[#E8E6E3] text-[#6B6B6B] hover:border-[#8B7355] hover:text-[#8B7355]'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Document Grid */}
      {filtered.length === 0 ? (
        <div className="bg-white border border-[#E8E6E3] rounded-lg p-12 text-center">
          <i className="ri-file-search-line text-3xl text-[#AEAAA4]"></i>
          <p className="text-sm text-[#9A9A9A] mt-3">No documents found</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((doc) => (
            <div
              key={doc.id}
              className="bg-white border border-[#E8E6E3] rounded-lg p-5 flex flex-col gap-4 hover:border-[#8B7355] transition-all group"
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-md flex-shrink-0 ${doc.color}`}>
                  <i className={`${doc.icon} text-base`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-[#1A1A1A] leading-tight">{doc.name}</p>
                  <p className="text-xs text-[#9A9A9A] mt-1">{doc.category}</p>
                </div>
              </div>
              <div className="flex items-center justify-between text-xs text-[#AEAAA4]">
                <span>{doc.date}</span>
                <span>{doc.size} · {doc.type}</span>
              </div>
              <button className="flex items-center justify-center gap-2 py-2 border border-[#E8E6E3] group-hover:border-[#8B7355] group-hover:text-[#8B7355] rounded-md text-xs text-[#6B6B6B] transition-all cursor-pointer">
                <i className="ri-download-line"></i>
                Download
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Footer note */}
      <div className="flex items-center gap-2 text-xs text-[#AEAAA4] mt-2">
        <i className="ri-lock-line"></i>
        All documents are encrypted and accessible only to authorised clients.
      </div>
    </div>
  );
}
